import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GenericService {
  deviceData = new BehaviorSubject<any>({
    accountNumber: null,
    businessName: null,
    address: null,
    city: null,
    state: null,
    countryCode: null,
    zip: null,
    modelNumber: null,
    machineImage: null,
    model: null,
    productLine: null,
    issueName: null,
    languageSelected: null,
    QRId: null,
    devices: [],
    machineType: null,
  });

  setSelectedMachineType(type: string) {
    const currentData = JSON.parse(localStorage.getItem('deviceData') || '{}');
    currentData.selectedMachineType = type;
    localStorage.setItem('deviceData', JSON.stringify(currentData));
  }

  getSelectedMachineType(): string | null {
    const data = JSON.parse(localStorage.getItem('deviceData') || '{}');
    return data?.selectedMachineType || null;
  }

  setLocalStorage(newData: any) {
    const currentData = JSON.parse(localStorage.getItem('deviceData') || '{}');
    const updatedData = { ...currentData, ...newData }; // Merge existing data with new data
    if (newData.model !== undefined) {
      updatedData.model = newData.model;
    }
    localStorage.setItem('deviceData', JSON.stringify(updatedData));
  }

  // Method to get data from local storage and update BehaviorSubject
  getLocalStorage() {
    let deviceData: any = localStorage.getItem('deviceData');
    if (deviceData) {
      this.deviceData.next(JSON.parse(deviceData));
    }
    return JSON.parse(deviceData);
  }

  constructor() {
    if (localStorage.getItem('deviceData')) {
      this.getLocalStorage();
    } else {
      this.setLocalStorage({
        accountNumber: null,
        businessName: null,
        address: null,
        city: null,
        state: null,
        countryCode: null,
        zip: null,
        modelNumber: null,
        machineImage: null,
        model: null,
        productLine: null,
        issueName: null,
        languageSelected: null,
        QRId: null,
        devices: [],
        machineType: null,
      });
    }
  }

  findObjectByKey(keyToFind: string, options: any[]): any {
    for (const option of options) {
      if (option.key === keyToFind) {
        return option;
      }

      if (option.steps) {
        for (const step of option.steps) {
          if (step.key === keyToFind) {
            return step;
          }
          const foundObject = this.findObjectByKey(
            keyToFind,
            step.options || [],
          );
          if (foundObject) {
            return foundObject;
          }
        }
      }
    }
    return null;
  }

  syncLocationFromQueryParams(queryMap: any, targetData: any): any {
    const data = targetData || {};
    const hasStateParam = queryMap?.has?.('state') ?? false;
    const hasPostalCodeParam = queryMap?.has?.('postalCode') ?? false;
    const hasCountryCodeParam = queryMap?.has?.('countryCode') ?? false;

    if (!hasStateParam && !hasPostalCodeParam && !hasCountryCodeParam) {
      return data;
    }

    if (hasStateParam) {
      data.state = (queryMap?.get?.('state') || '').trim() || null;
    }

    if (hasPostalCodeParam) {
      data.zip = (queryMap?.get?.('postalCode') || '').trim() || null;
    }

    if (hasCountryCodeParam) {
      data.countryCode = (queryMap?.get?.('countryCode') || '').trim() || null;
    }

    return data;
  }
}
